var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('header-divider');
import { breakpoints, theme } from '@shapeable/theme';
export var HeaderDividerDefaultProps = {
  lineColor: 'secondary'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: 500;\n    \n    color: ", ";\n    text-align: center;\n    line-height: 1.1em;\n    text-transform: uppercase;\n    width: 100%;\n    box-sizing: border-box;\n  "], ["\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: 500;\n    \n    color: ", ";\n    text-align: center;\n    line-height: 1.1em;\n    text-transform: uppercase;\n    width: 100%;\n    box-sizing: border-box;\n  "])), theme.FONT_SIZE(24), theme.FONT('sans'), theme.COLOR('secondary')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(28)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(32))
});
var DividerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n    ", "\n    height: 2px;\n    flex-basis: 40%;\n    flex-shrink: 1;\n  "], ["\n\n    ", "\n    height: 2px;\n    flex-basis: 40%;\n    flex-shrink: 1;\n  "])), function (_a) {
    var lineColor = _a.lineColor;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.H_DOT_BG(lineColor, 2, 6));
  })
});
var StartStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), DividerStyles)
});
var EndStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), DividerStyles)
});
var BodyStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-basis: 80%;\n    padding-left: ", ";\n    padding-right: ", ";\n    flex-grow: 1;\n  "], ["\n    flex-basis: 80%;\n    padding-left: ", ";\n    padding-right: ", ";\n    flex-grow: 1;\n  "])), theme.UNIT(2), theme.UNIT(2)),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    flex-basis: auto;\n    flex-shrink: 0;\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    flex-basis: auto;\n    flex-shrink: 0;\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(6), theme.UNIT(6))
}); // -------- Components -------->

var My = {
  Container: styled.h2(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Start: styled.span.attrs(cls.attr('start'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  End: styled.span.attrs(cls.attr('end'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), EndStyles),
  Body: styled.span.attrs(cls.attr('body'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var HeaderDivider = function HeaderDivider(props) {
  var className = props.className,
      children = props.children,
      lineColor = props.lineColor;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Start, {
    lineColor: lineColor
  }), React.createElement(My.Body, null, children), React.createElement(My.End, {
    lineColor: lineColor
  }));
};
HeaderDivider.defaultProps = HeaderDividerDefaultProps;
HeaderDivider.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;